import {FC} from 'react'
import {useLocation} from 'react-router-dom'
import queryString from 'query-string'
import {useQuery} from 'hooks/graphql'
import {Presenter} from './Presenter'
import {EMPLOYEE, QueryVariables, QueryResult} from './query'

export const Detail: FC = () => {
  const {search} = useLocation()
  const {employee_id: employeeId} = queryString.parse(search)
  const {data, loading} = useQuery<QueryResult, QueryVariables>(EMPLOYEE, {variables: {id: String(employeeId)}})

  return !loading && data ? <Presenter employee={data.client.employee} /> : <></>
}
